<template lang="pug">
.new-faq
  shForm(title="Nueva FAQ")
</template>

<script>
import shForm from '@/components/pages/faq/Form'

export default {
  name: 'NewFaq',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-faq
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/faq/New.vue